"use strict";
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);
var types_generated_exports = {};
__export(types_generated_exports, {
  isProjectTransferRequest: () => isProjectTransferRequest,
  isProjectTransferResult: () => isProjectTransferResult,
  isSurveyTransferRequest: () => isSurveyTransferRequest,
  isSurveyTransferResult: () => isSurveyTransferResult,
  isTransferResult: () => isTransferResult,
  isUserTransferRequest: () => isUserTransferRequest,
  isUserTransferResult: () => isUserTransferResult
});
module.exports = __toCommonJS(types_generated_exports);
var import_types_generated = require("../core/types.generated.js");
const isSurveyTransferRequest = (v) => {
  return typeof v === "object" && v != null && "srcProject" in v && (0, import_types_generated.isProjectId)(v.srcProject) && "srcModule" in v && (0, import_types_generated.isSurveyModuleId)(v.srcModule) && "desProject" in v && (0, import_types_generated.isProjectId)(v.desProject) && "desModule" in v && (0, import_types_generated.isSurveyModuleId)(v.desModule) && "surveys" in v && Array.isArray(v.surveys) && v.surveys.every((i) => (0, import_types_generated.isSurveyId)(i)) && "teamMappings" in v && Array.isArray(v.teamMappings) && v.teamMappings.every(
    (i) => Array.isArray(i) && i.length === 2 && ((0, import_types_generated.isTeamId)(i[0]) || i[0] === null) && ((0, import_types_generated.isTeamId)(i[1]) || i[1] === null)
  ) && "copy" in v && typeof v.copy === "boolean";
};
const isUserTransferRequest = (v) => {
  return typeof v === "object" && v != null && "srcWorkspace" in v && (0, import_types_generated.isWorkspaceId)(v.srcWorkspace) && "desWorkspace" in v && (0, import_types_generated.isWorkspaceId)(v.desWorkspace) && "users" in v && Array.isArray(v.users) && v.users.every((i) => (0, import_types_generated.isUserId)(i)) && "projectMappings" in v && Array.isArray(v.projectMappings) && v.projectMappings.every(
    (i) => Array.isArray(i) && i.length === 2 && (0, import_types_generated.isProjectId)(i[0]) && ((0, import_types_generated.isProjectId)(i[1]) || i[1] === null)
  ) && "teamMappings" in v && Array.isArray(v.teamMappings) && v.teamMappings.every(
    (i) => Array.isArray(i) && i.length === 2 && (0, import_types_generated.isTeamId)(i[0]) && ((0, import_types_generated.isTeamId)(i[1]) || i[1] === null)
  ) && "transferSurveys" in v && typeof v.transferSurveys === "boolean";
};
const isProjectTransferRequest = (v) => {
  return typeof v === "object" && v != null && "srcProject" in v && (0, import_types_generated.isProjectId)(v.srcProject) && "desWorkspace" in v && (0, import_types_generated.isWorkspaceId)(v.desWorkspace) && "transferMembers" in v && typeof v.transferMembers === "boolean" && "leaveBreadcrumb" in v && typeof v.leaveBreadcrumb === "boolean";
};
const isTransferResult = (isA) => (v) => {
  return typeof v === "object" && v != null && "failed" in v && Array.isArray(v.failed) && v.failed.every((i) => isA(i)) && "successful" in v && Array.isArray(v.successful) && v.successful.every((i) => isA(i));
};
const isUserTransferResult = (v) => {
  return typeof v === "object" && v != null && "users" in v && isTransferResult((a0) => (0, import_types_generated.isUserId)(a0))(v.users) && "surveys" in v && isTransferResult((a0) => (0, import_types_generated.isSurveyId)(a0))(v.surveys);
};
const isSurveyTransferResult = (v) => {
  return typeof v === "object" && v != null && "surveys" in v && isTransferResult((a0) => (0, import_types_generated.isSurveyId)(a0))(v.surveys);
};
const isProjectTransferResult = (v) => {
  return typeof v === "object" && v != null && "projects" in v && isTransferResult((a0) => (0, import_types_generated.isProjectId)(a0))(v.projects);
};
// Annotate the CommonJS export names for ESM import in node:
0 && (module.exports = {
  isProjectTransferRequest,
  isProjectTransferResult,
  isSurveyTransferRequest,
  isSurveyTransferResult,
  isTransferResult,
  isUserTransferRequest,
  isUserTransferResult
});
//# sourceMappingURL=types.generated.js.map
